import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	linkWithoutDecoration: {
		textDecoration: "none"
	}
}))

export default useStyles
